var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _line, _line2, _line3, _line4, _path12, _path13, _line5, _line6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 199,
    viewBox: "0 0 268 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 100,
    r: 43,
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 100.5C172.5 78.9609 155.039 61.5 133.5 61.5M94.5 100.5C94.5 119.474 108.049 135.283 126 138.78",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 48V19.5C3.5 11.2157 10.2157 4.5 18.5 4.5H79.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.5V21.5C10.5 15.9772 14.9772 11.5 20.5 11.5H24.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.5 151.5V180C264.5 188.284 257.784 195 249.5 195H188.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5 174V178C257.5 183.523 253.023 188 247.5 188H243.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.5 48V19.5C264.5 11.2157 257.784 4.5 249.5 4.5H188.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5 25.5V21.5C257.5 15.9772 253.023 11.5 247.5 11.5H243.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 151.5V180C3.5 188.284 10.2157 195 18.5 195H79.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 174V178C10.5 183.523 14.9772 188 20.5 188H24.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 100.5L5.5 104L8.5 107.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5 108.5L263.5 105L260.5 101.5",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 104,
    x2: 86.5,
    y2: 104,
    stroke: "#D9D9D9",
    strokeDasharray: "4 4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 263.5,
    y1: 105,
    x2: 183.5,
    y2: 105,
    stroke: "#D9D9D9",
    strokeDasharray: "4 4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 134,
    y1: 4.5,
    x2: 134,
    y2: 52.5,
    stroke: "#D9D9D9",
    strokeDasharray: "4 4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 134,
    y1: 195.5,
    x2: 134,
    y2: 146.5,
    stroke: "#D9D9D9",
    strokeDasharray: "4 4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.721 92.992V100H131.169V93.312H127.473V100H125.921V91.92H127.089L127.473 92.576L128.609 91.92H130.865L132.721 92.992ZM142.08 99.008L140.224 100.08H137.136L135.28 99.008V92.992L137.136 91.92H140.224L142.08 92.992V99.008ZM136.832 93.312V98.688H140.528V93.312H136.832ZM106.989 112.72V114.688H110.205V112.72H106.989ZM107.293 116.08L105.437 115.008V112.4L107.293 111.328H110.205V109.392H106.237V108H109.901L111.757 109.072V116.08H111.341L110.205 115.424L109.069 116.08H107.293ZM114.879 108L117.231 114.528H117.263L119.631 108H121.151L118.191 116H116.319L113.359 108H114.879ZM124.309 108V116H122.757V108H124.309ZM122.677 106.032V104.32H124.389V106.032H122.677ZM128.098 112.72V114.688H131.314V112.72H128.098ZM128.402 116.08L126.546 115.008V112.4L128.402 111.328H131.314V109.392H127.346V108H131.01L132.866 109.072V116.08H132.45L131.314 115.424L130.178 116.08H128.402ZM134.788 109.392V108H136.26V106.656L137.812 105.76V108H139.732V109.392H137.812V114.608H139.732V116H138.116L136.26 114.928V109.392H134.788ZM143.527 108V116H141.975V108H143.527ZM141.895 106.032V104.32H143.607V106.032H141.895ZM152.885 115.008L151.029 116.08H147.941L146.085 115.008V108.992L147.941 107.92H151.029L152.885 108.992V115.008ZM147.637 109.312V114.688H151.333V109.312H147.637ZM162.244 108.992V116H160.692V109.312H156.996V116H155.444V107.92H156.612L156.996 108.576L158.132 107.92H160.388L162.244 108.992Z",
    fill: "#BCBBBE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.299 72.25L141.227 84.25C141.805 85.25 141.083 86.5 139.928 86.5H126.072C124.917 86.5 124.195 85.25 124.773 84.25L131.701 72.25C132.278 71.25 133.722 71.25 134.299 72.25Z",
    stroke: "#D9D9D9"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 133,
    y1: 76,
    x2: 133,
    y2: 82,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 133,
    y1: 83,
    x2: 133,
    y2: 85,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPlane);
export default __webpack_public_path__ + "static/media/no-plane.9aba2bcbe6c0ac3fca2c0b47e4d7c03a.svg";
export { ForwardRef as ReactComponent };